var dataReceiveCountStore = require('../data-receive-count/data-receive-count-store.js');

function DataStreamProfileStore()
{
    var profileCache = {};

    function removeOldProfile() {
        for(var topicId in profileCache){
            var passedHours = Math.abs(new Date().getTime() - profileCache[topicId].lastUpdated.getTime()) / 3600000;
            if(passedHours > 8) {
                this.remove(topicId);
            }
        };
    }

    function getDataReceiveCountProfile()
    {
        var dataStreamProfile = {};
        dataStreamProfile.dataFields = [];
        var dataStreamIds = dataReceiveCountStore.getAllTrackingDataStreamIds();
        for (var i in dataStreamIds)
        {
            dataStreamProfile.dataFields.push({name:dataStreamIds[i]});
        }
        return dataStreamProfile;
    }

    //this.store = function(dataStreamId, dataStreamProfile)
    //{
    //    profileCache[dataStreamId] = {
    //        data: dataStreamProfile,
    //        lastUpdated: new Date()
    //    };
    //
    //    removeOldProfile();
    //}

    this.store = function(dataProfile)
    {

        var id = dataProfile.persistenceId;
        profileCache[id] = {
            data: dataProfile,
            lastUpdated: new Date()
        };

        removeOldProfile();
    }

    this.get = function(dataProfileId)
    {
        if (dataProfileId === 'DATA.RECEIVE.COUNT')
        {
            return getDataReceiveCountProfile();
        }

        if (profileCache[dataProfileId] == null)
        {
            throw 'Data stream profile does not exist for ' + dataProfileId;
        }
        else
        {
            profileCache[dataProfileId].lastUpdated = new Date();
            return profileCache[dataProfileId].data;
        }
    }

    this.doesProfileExist = function(dataStreamId)
    {
        if (dataStreamId === 'DATA.RECEIVE.COUNT')
        {
            return true;
        }

        if (profileCache[dataStreamId] == null)
        {
            return false;
        }
        else
        {
            return true;
        }
    }

    this.remove = function(topicId)
    {
        if (profileCache.hasOwnProperty(topicId))
        {
            delete profileCache[topicId];
        }
    }
}

module.exports = new DataStreamProfileStore();


// WEBPACK FOOTER //
// ./src-client-lib/api/data-stream-profile-store.js